import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RaciService } from '../../services/raci.service';
import { EventBusService } from '../../../../services/event-bus.service';

/**
 * Handles tree list view component
 */
@Component({
  selector: 'tree-list-view',
  templateUrl: './tree-list-view.component.html',
  styleUrls: ['./tree-list-view.component.css']
})
export class TreeListViewComponent {
  /**
 * Input: data
 */
  @Input() data;

  /**
   * Input: showBackIcon
   */
  @Input() showBackIcon = true;

  /**
   * Input: activeOid
   */
  @Input() activeOid: any;

  /**
   * Input: showConfirmDialog
   */
  @Input() showConfirmDialog;

  /**
   * Output: onSetActive
   */
  @Output() onSetActive: EventEmitter<any> = new EventEmitter();

  /**
   * Constructor
   * @param _raciService Raci service
   */
  constructor(private _raciService: RaciService,
    private eventBus: EventBusService) { }

  /**
   * Go back event
   * */
  goBack() {
    this._raciService.showProjectStepsEvent();
  }

  /**
   * Sets active item
   * @param _event Item click event
   * @param item Selected item
   */
  setActive(_event: any, item: any) {
    if (!this.showConfirmDialog) {
      this.activeOid = item.oid;
      this.onSetActive.emit(item);
    }
    else {
      this.displayUnsavedChangesDialog();
    }
  }

  /**
   * Displays unsaved changes dialog
   * */
  private displayUnsavedChangesDialog() {
    this.eventBus.broadcastEvent("openConfirmDialog", {
      success: () => {
        //Nothing
      }
    }, 'saveApproval');
  }
}
